import { useEffect, useState } from "react";

const peutInterroger = () => typeof window !== "undefined" && typeof window.matchMedia === "function";

// Abonnement à une requête média (ex. "(max-width: 991px)"). Sans matchMedia
// (jsdom, très vieux navigateurs), la requête est considérée fausse.
export default function useMediaQuery(requete) {
  const [correspond, setCorrespond] = useState(() => (peutInterroger() ? window.matchMedia(requete).matches : false));

  useEffect(() => {
    if (!peutInterroger()) return undefined;
    const media = window.matchMedia(requete);
    const surChangement = (evenement) => setCorrespond(evenement.matches);
    setCorrespond(media.matches);
    if (typeof media.addEventListener === "function") {
      media.addEventListener("change", surChangement);
      return () => media.removeEventListener("change", surChangement);
    }
    // Safari < 14
    media.addListener(surChangement);
    return () => media.removeListener(surChangement);
  }, [requete]);

  return correspond;
}
